// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"72":"b77a47ad","398":"3934a79c","418":"cbf4a06d"}[chunkId] + ".chunk.css";
};